import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  RdsCustomIconComponent,
  RdsIconComponent,
  RdsSidenavComponent,
  RdsSidenavMenuitemComponent,
} from '@rds/angular-components';

import { HasAccessDirective, Permission, RoleType } from '@bookly/shared';

/**
 * The admin navigation menu, rendered both in the desktop sidenav and inside
 * the mobile drawer.
 *
 * This is a component rather than an `<ng-template>` shared via
 * `ngTemplateOutlet` because `rds-sidenav-menuitem` injects the
 * `RdsSidenavService` that `rds-sidenav` provides. An outlet renders its view
 * in the injector of the place the template was *declared*, so the menu items
 * would not find that service. Owning the `<rds-sidenav>` here keeps them in
 * the right injector.
 */
@Component({
  selector: 'bad-dashboard-nav',
  templateUrl: './dashboard-nav.component.html',
  styleUrl: './dashboard-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.dashboard-nav--in-drawer]': 'inDrawer()',
  },
  imports: [
    RouterLink,
    RouterLinkActive,
    RdsIconComponent,
    RdsCustomIconComponent,
    RdsSidenavComponent,
    RdsSidenavMenuitemComponent,
    HasAccessDirective,
  ],
})
export class DashboardNavComponent {
  public readonly role = input<RoleType | null>(null);

  /** Collapses the sidenav to the 72px icon rail. */
  public readonly collapsed = input(false);

  /**
   * Set when rendered inside the mobile drawer, which brings its own chrome and
   * close affordance — so the expand toggle and the divider border are dropped.
   */
  public readonly inDrawer = input(false);

  protected readonly RoleType = RoleType;
  protected readonly Permission = Permission;
}
